import "./index.css";
import React, { useEffect, useRef, useState } from "react";

import Sidebar from "components/Sidebar/Sidebar.js";
import CardTable from "components/Cards/CardTable";
import axios from "axios";
import { TableDataItem } from "components/Cards/CardTable";
import {colors} from '../../utils/theme'
/* import { useStore } from "../../context/store/store";
 */ import { Spinner } from "components/Spinner";
import { useStore } from "context/store/store";
import config from "services/config";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import AddCommentIcon from "@mui/icons-material/AddComment";
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import {
  Box,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useLayout } from "context/layout/layout";
import { PAYMENTS } from "utils/state";
import { formatCLP } from "utils";
import { useAuth } from "context/auth/auth";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { DailyHeader } from "components/DailyHeader";
import { useLegacy } from "context/legacy/legacy";
import { TextInput } from "components/TextInput";
import {
  Cancel,
  CancelOutlined,
  CardMembership,
  Check,
  Close,
  Edit,
  InsertChart,
  RefreshSharp,
  Save,
} from "@mui/icons-material";
import { getTextOfJSDocComment } from "typescript";

let icons = {
  color: "#cbd5e1",
  fontSize: 25,
  margin: "0 10px",
};

export function Daily({ color = null }) {
  const { legacy, setLegacy } = useLegacy();
  const store = useStore();
  const auth = useAuth();
  const layout = useLayout();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentDocument, setCurrentDocument] = useState(null);
  const [currentItemType, setCurrentItemType] = useState(null);
  const [editing, setEditing] = useState(false);
  const [newPrice, setNewPrice] = useState("");

  const handleMenu = (event, document, type) => {
    console.log({ currentItemType });
    console.log({ type });
    console.log({ anchorEl });
    // If the clicked menu is already open, close it
    if (currentItemType === type && anchorEl) {
      closeMenu();
    } else {
      // Otherwise, open the new menu
      setCurrentDocument(document);
      setCurrentItemType(type);
      setAnchorEl(event.currentTarget);
      setMenuOpen(true);
    }
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setCurrentItemType(null);
    setMenuOpen(false);
  };

  const handleMenuItemClick = async (payment) => {
    if (currentItemType === "price") {
      return;
    }
    let ID = currentDocument._id;

    setLoading(true);

    await axios.post(
      `${config.url}/${currentItemType}/update/${ID}`,
      {
        payment,
      },
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    );

    store
      .verifyShift()
      .then((res) => {
        setLoading(false);
        setShift(res);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });

    closeMenu();
  };

  const [initialBalance, setInitialBalance] = useState(null);

  const [shift, setShift] = useState({
    isInProgress: false,
    shift: null,
  });

  const handleInitialBalance = ({ target: { value } }) => {
    setInitialBalance(value);
  };

  const [message, setMessage] = useState({
    isOpen: false,
  });

  useEffect(() => {
    store
      .verifyShift()
      .then((res) => {
        console.log({ res });
        setLoading(false);
        setShift(res);
      })
      .catch((err) => {
        console.log(err);
      });
    // eslint-disable-next-line
  }, []);

  const handleOpenShift = () => {
    setMessage({
      ...message,
      isOpen: true,
      title: `Usted esta apunto de abrir caja para el dia ${new Date().toLocaleDateString()}`,
      body: "Confirme la acción selecionada",
    });
  };

  const handleCancel = () => {
    setMessage({
      ...message,
      isOpen: false,
    });
  };

  const handleConfirm = () => {
    setLoading(true);
    setMessage({
      ...message,
      isOpen: false,
    });
    openShift();
  };

  const openShift = () => {
    store
      .openShift({ initialBalance })
      .then((res) => {
        setLoading(false);
        setShift({
          isInProgress: true,
          shift: res,
        });
        layout.successAlert({ message: "Apertura de turno exitosa" });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        layout.errorAlert({ message: `Error en el servicio: ${err}` });
      });
  };

  const handleConfirmDelete = () => {
    store
      .deleteShift(shift.shift._id)
      .then((res) => {
        console.log(res);
        setShift({
          isInProgress: false,
          shift: null,
        });
        setMessage({
          ...message,
          isOpen: false,
        });
        layout.successAlert({ message: `Turno eliminado con éxito` });
      })
      .catch((err) => {
        console.log(err);
        layout.errorAlert({ message: `Error en el servicio: ${err}` });
      });
  };

  const handleDelete = () => {
    setMessage({
      ...message,
      isOpen: true,
      title: "Desea eliminar este turno",
      body: "Esta accioón es irreversible, verifique antes de eliminar el turno",
      handleConfirm: () => handleConfirmDelete(),
    });
  };

  const navigateToNewOrder = () => {
    navigate(`/sales/add`, {
      state: { shiftId: shift.shift._id, type: "gym" },
    });
  };
  const navigateToEnrollment = () => {
    navigate(`/enrollment/add`, {
      state: { shiftId: shift.shift._id },
    });
  };

  const navigateToNewEnrollment = () => {
    navigate(`/enrollment/new`, {
      state: { shiftId: shift.shift._id },
    });
  };

  function calculateCash() {
    if (!shift.paymentResume) {
      return 0;
    }
    let cashItem = shift.paymentResume.find((p) => p.code === "CASH") || null;
    return cashItem.amount;
  }

  const navigateToWithdraw = () => {
    let cash = calculateCash();
    if (cash < 1) {
      return layout.errorAlert({ message: "No existe efectivo para retirar" });
    }

    navigate(`/withdraw/add`, {
      state: { shiftId: shift.shift._id, cashAmount: cash },
    });
  };
  const navigateToComment = () => {
    navigate(`/comment/add`, {
      state: { shiftId: shift.shift._id },
    });
  };

  const navigateToExpense = () => {
    let cash = calculateCash();
    if (cash < 1) {
      return layout.errorAlert({ message: "No existe efectivo para retirar" });
    }
    navigate(`/expense/add`, {
      state: { shiftId: shift.shift._id, cashAmount: cash },
    });
  };

  function navigateToDetails(detail) {
    console.log(detail);
    navigate(`/sales/view/${detail._id}`, {
      state: { detail: detail },
    });
  }

  function getPaymentName(payment) {
    let obj = PAYMENTS.find((p) => p.code === payment) || null;
    if (obj) {
      return obj.name;
    }
    return "";
  }

  /*   function handleFilter() {
    let ID = "6530104efceb095a24e9f83d";
    let newSales = shift.shift.sales.filter((s) => s.salesman._id === ID);
    let newEnrollments = shift.shift.enrollments.filter(
      (s) => s.salesman._id === ID
    );
    setShift({
      ...shift,
      shift: {
        ...shift.shift,
        sales: newSales,
        enrollments: newEnrollments,
      },
    });
  } */

  async function removeMovement(movementId, movementType) {
    console.log(movementType);
    console.log(movementId);
    setLoading(true);
    try {
      let { data } = await axios.post(
        `${config.url}/access_log/remove/${movementId}`,
        {
          type: movementType,
        },
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      console.log(data);
      layout.successAlert({ message: "Movimiento eliminado correctamente" });
      store
        .verifyShift()
        .then((res) => {
          console.log({ res });
          setLoading(false);
          setShift(res);
        })
        .catch((err) => {
          setLoading(false);
          layout.errorAlert({ message: `Error en el servicio: ${err}` });

          console.log(err);
        });
    } catch (err) {
      setLoading(false);
      layout.errorAlert({ message: "Error al eliminar el movimiento" });

      console.log(err);
    }
  }

  function handlePriceConfirmation() {
    setMessage({
      ...message,
      isOpen: true,
      title: "Esta seguro que desea modificar el precio",
      body: "Verifique antes de modificar el precio",
      handleConfirm: () => handleConfirmNewPrice(),
    });
  }

  async function handleConfirmNewPrice() {
    setLoading(true);

    const response = await axios.post(
      `${config.url}/enrollment/update/${currentDocument._id}`,
      {
        totalPrice: Number(newPrice),
      },
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    );

    console.log(response);

    if (response.status === 200) {
      store
        .verifyShift()
        .then((res) => {
          setLoading(false);
          setShift(res);
          layout.successAlert({ message: `Precio modificado con exito` });
          closeMenu();
          setMessage({
            ...message,
            isOpen: false,
          });
          setNewPrice("");
          setEditing(false);
        })
        .catch((err) => {
          layout.errorAlert({ message: `Error en el servicio` });

          setLoading(false);
        });
      return;
    }
    layout.errorAlert({ message: `Error en el servicio` });
  }

  function handleEdit(enrollmentDocument) {
    if (editing && newPrice) {
      handlePriceConfirmation();
      return;
    }
    setEditing(!editing);
    setCurrentDocument(enrollmentDocument);
  }

  return (
    <>
      {loading && <Spinner />}
      <Sidebar />
      <div
        className="relative text-white "
        id="daily-gym"
        style={{
          backgroundColor:'#fff',
          height: "100%",
          minHeight: "100vh",
        }}
      >
        <div>
          <div className="py-3 px-4">
            <DailyHeader shift={shift} handleOpenShift={handleOpenShift} />

            {shift && shift.shift && (
              <div>
                <div className="flex items-center ">
                  <p
                    style={{ background: colors.mantis, width: "fit-content" }}
                    className="px-2 text-white rounded my-2 mr-2 font-light"
                  >
                    En progreso
                  </p>
                  {/*            <p
                    style={{ background: "#0369a1", width: "fit-content" }}
                    className="px-2 text-white rounded my-2 mr-2"
                  >
                    ID {shift.shift._id}
                  </p> */}
                  <p
                    style={{
                      background: colors.mantis,
                      width: "fit-content",
                      display: "flex",
                    }}
                    className="px-2 text-white rounded my-1 items-center font-light"
                  >
                    Apertura: {shift.shift.timeopen.split("T")[1].slice(0, 8)}
                  </p>
                </div>
              </div>
            )}
          </div>
          {shift && shift.shift && shift.shift.sales && (
            <div style={{ width: "100%" }}>
              <div className="flex justify-between items-center rounded-md px-3 py-2">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "auto",
                  }}
                >
                  <div className="mx-1">
                    <Tooltip title="Comentarios">
                      <Button
                        sx={{
                          color: "#fff",
                          fontSize: 12,
                        }}
                        variant="contained"
                        color="info"
                        size="small"
                        onClick={navigateToComment}
                      >
                        <AddCommentIcon sx={{ fontSize: 20 }} />
                      </Button>
                    </Tooltip>
                  </div>
                  <div className="mx-1">
                    <Tooltip title="Retiro">
                      <Button
                        sx={{
                          color: "#fff",
                          fontSize: 12,
                        }}
                        variant="contained"
                        color="warning"
                        size="small"
                        onClick={navigateToWithdraw}
                      >
                        <AttachMoneyIcon sx={{ fontSize: 20 }} />
                      </Button>
                    </Tooltip>
                  </div>
                  <div className="mx-1">
                    <Tooltip title="Gasto">
                      <Button
                        sx={{
                          color: "#fff",
                          fontSize: 12,
                        }}
                        variant="contained"
                        color="warning"
                        size="small"
                        onClick={navigateToExpense}
                      >
                        <AttachMoneyIcon sx={{ fontSize: 20 }} />
                      </Button>
                    </Tooltip>
                  </div>

                  <div className="mx-1">
                    <Tooltip title="Venta">
                      <Button
                        sx={{
                          color: "#fff",
                          fontSize: 12,
                        }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={navigateToNewOrder}
                      >
                        <ShoppingCartIcon sx={{ fontSize: 20 }} />
                      </Button>
                    </Tooltip>
                  </div>

                  <div className="mx-1">
                    <Tooltip title="Renovación">
                      <Button
                        sx={{
                          color: "#fff",
                          backgroundColor: '#be185d',
                          fontSize: 12,
                        }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={navigateToEnrollment}
                      >
                        <AutoModeIcon sx={{ fontSize: 20 }} />
                      </Button>
                    </Tooltip>
                  </div>

                  <div className="mx-1 ">
                    <Tooltip title="Inscripción">
                      <Button
                        sx={{
                          color: "#fff",
                          fontSize: 12,
                          backgroundColor: '#be185d'
                        }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={navigateToNewEnrollment}
                      >
                        <LoyaltyIcon sx={{ fontSize: 20 }} />
                      </Button>
                    </Tooltip>
                  </div>

                  <IconButton
                    sx={{ margin: 0, padding: 0 }}
                    onClick={handleDelete}
                  >
                    <DeleteIcon sx={{ ...icons, color: "#b91c1c" }} />
                  </IconButton>
                  {/* 
                  <IconButton
                    sx={{ margin: 0, padding: 0 }}
                    onClick={handleFilter}
                  >
                    <FilterListIcon sx={{ ...icons, color: "#ccc" }} />
                  </IconButton> */}
                </div>
              </div>
              <CardTable
                headers={[
                  "Vendedor",
                  "Hora",
                  "Monto",
                  "Cliente",
                  "Método de pago",
                  "Acciones",
                ]}
                color={"dark"}
              >
                {shift.shift.sales.map((saleDocument, index) => {
                  return (
                    <tr>
                      <TableDataItem
                        sx={{
                          fontWeight: 500,
                          fontSize: 12,
                          textAlign: "left",
                          transform: "translateX(25px)",
                        }}
                      >
                        {saleDocument.salesman?.name}
                      </TableDataItem>
                      <TableDataItem
                        sx={{
                          fontSize: 12,
                        }}
                      >
                        {saleDocument.date.split("T")[1].slice(0, 8)}
                      </TableDataItem>
                      <TableDataItem
                        sx={{
                          fontSize: 12,
                        }}
                      >
                        {formatCLP(saleDocument.totalPrice)}
                      </TableDataItem>
                      <TableDataItem
                        sx={{
                          fontSize: 12,
                        }}
                      >
                        {saleDocument.member
                          ? saleDocument.member.id_number
                          : "No hay cliente"}
                      </TableDataItem>
                      <TableDataItem
                        sx={{
                          fontSize: 12,
                        }}
                      >
                        {getPaymentName(saleDocument.payment)}
                      </TableDataItem>
                      <TableDataItem>
                        <IconButton
                          id="basic-button-sales"
                          aria-controls={
                            menuOpen ? "basic-menu-sales" : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={menuOpen ? "true" : undefined}
                          onClick={(e) => handleMenu(e, saleDocument, "sales")}
                        >
                          <CurrencyExchangeIcon
                            sx={{ color: "#ccc", fontSize: 20 }}
                          />
                          <Menu
                            key={index}
                            id="basic-menu-sales"
                            PaperProps={{
                              sx: {
                                bgcolor: "#075985", // Color de fondo del Paper
                                color: "#fff", // Color del texto dentro del Paper
                              },
                            }}
                            anchorEl={anchorEl}
                            open={menuOpen}
                            onClose={closeMenu}
                            MenuListProps={{
                              "aria-labelledby": "basic-button-sales",
                            }}
                          >
                            <MenuItem
                              onClick={() => handleMenuItemClick("CASH")}
                              sx={{ fontSize: 14 }}
                            >
                              Efectivo
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                handleMenuItemClick("BANK_TRANSFER")
                              }
                              sx={{ fontSize: 14 }}
                            >
                              Transferencia
                            </MenuItem>
                            <MenuItem
                              onClick={() => handleMenuItemClick("CARD")}
                              sx={{ fontSize: 14 }}
                            >
                              Tarjeta Débito o Crédito
                            </MenuItem>
                          </Menu>
                        </IconButton>
                        <IconButton
                          onClick={() => navigateToDetails(saleDocument)}
                        >
                          <VisibilityIcon
                            sx={{ color: "#ccc", fontSize: 20 }}
                          />
                        </IconButton>

                        {auth.isAdmin && (
                          <IconButton
                            onClick={() =>
                              removeMovement(saleDocument._id, "sale")
                            }
                          >
                            <DeleteIcon sx={{ color: "#ccc", fontSize: 20 }} />
                          </IconButton>
                        )}
                      </TableDataItem>
                    </tr>
                  );
                })}
                {shift.shift.enrollments.map((enrollmentDocument, index) => {
                  return (
                    <tr>
                      <TableDataItem
                        sx={{
                          opacity: editing ? 0.2 : 1,
                          fontWeight: 500,
                          fontSize: 12,
                          textAlign: "left",
                          transform: "translateX(25px)",
                        }}
                      >
                        {enrollmentDocument.salesman?.name}
                      </TableDataItem>
                      <TableDataItem
                        sx={{ fontSize: 12, opacity: editing ? 0.2 : 1 }}
                      >
                        {enrollmentDocument.date.split("T")[1].slice(0, 8)}
                      </TableDataItem>
                      {currentDocument &&
                      currentDocument._id === enrollmentDocument._id &&
                      editing ? (
                        <TableDataItem>
                          <div
                            className="w-full mx-auto   "
                            style={{ maxWidth: 150 }}
                          >
                            <input
                              style={{ maxWidth: 150 }}
                              value={newPrice}
                              onChange={(e) => {
                                setNewPrice(e.target.value);
                              }}
                              type="text"
                              name="price"
                              id="price"
                              class="block bg-transparent border-zinc-500  rounded  py-1 pl-7 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-none focus:ring-0 sm:text-sm/6"
                              placeholder={enrollmentDocument.totalPrice}
                            />
                          </div>
                        </TableDataItem>
                      ) : (
                        <TableDataItem
                          sx={{ fontSize: 12, opacity: editing ? 0.2 : 1 }}
                        >
                          <div>{formatCLP(enrollmentDocument.totalPrice)}</div>
                        </TableDataItem>
                      )}
                      <TableDataItem
                        sx={{
                          fontSize: 12,
                          opacity: editing ? 0.2 : 1,
                        }}
                      >
                        {enrollmentDocument.member
                          ? enrollmentDocument.member.id_number
                          : "No hay cliente"}
                      </TableDataItem>
                      <TableDataItem
                        sx={{ fontSize: 12, opacity: editing ? 0.2 : 1 }}
                      >
                        {getPaymentName(enrollmentDocument.payment)}
                      </TableDataItem>
                      <TableDataItem>
                        <IconButton
                          sx={{ opacity: editing ? 0.2 : 1 }}
                          id="enrollment-button"
                          aria-controls={
                            menuOpen && currentItemType === "enrollment"
                              ? "enrollment-menu"
                              : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={
                            menuOpen && currentItemType === "enrollment"
                              ? "true"
                              : undefined
                          }
                          onClick={(e) =>
                            handleMenu(e, enrollmentDocument, "enrollment")
                          }
                        >
                          <CurrencyExchangeIcon
                            sx={{ color: "#ccc", fontSize: 20 }}
                          />
                          <Menu
                            id="enrollment-menu"
                            anchorEl={anchorEl}
                            open={menuOpen && currentItemType === "enrollment"}
                            onClose={closeMenu}
                            sx={{
                              visibility:
                                currentItemType === "enrollment"
                                  ? "visible"
                                  : "hidden",
                            }}
                            PaperProps={{
                              sx: {
                                bgcolor: "#075985", // Background color
                                color: "#fff", // Text color
                              },
                            }}
                            MenuListProps={{
                              "aria-labelledby": "enrollment-button",
                            }}
                          >
                            <MenuItem
                              onClick={() => handleMenuItemClick("CASH")}
                              sx={{ fontSize: 14 }}
                            >
                              Efectivo
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                handleMenuItemClick("BANK_TRANSFER")
                              }
                              sx={{ fontSize: 14 }}
                            >
                              Transferencia
                            </MenuItem>
                            <MenuItem
                              onClick={() => handleMenuItemClick("CARD")}
                              sx={{ fontSize: 14 }}
                            >
                              Tarjeta Débito o Crédito
                            </MenuItem>
                          </Menu>
                        </IconButton>

                        <IconButton
                          onClick={() => handleEdit(enrollmentDocument)}
                        >
                          {currentDocument &&
                          currentDocument._id === enrollmentDocument._id &&
                          editing ? (
                            <>
                              <Tooltip title="Confirmar">
                                <Check
                                  sx={{
                                    color: "green",
                                    fontSize: 25,
                                    opacity: editing ? 1 : 0.2,
                                  }}
                                />
                              </Tooltip>
                            </>
                          ) : (
                            <Tooltip title="Editar precio">
                              <Edit
                                sx={{
                                  color: "#ccc",
                                  fontSize: 20,
                                  opacity: editing ? 0.2 : 1,
                                }}
                              />
                            </Tooltip>
                          )}
                        </IconButton>
                        {currentDocument &&
                        currentDocument._id === enrollmentDocument._id &&
                        editing ? (
                          <IconButton
                            onClick={() => {
                              setEditing(false);
                            }}
                          >
                            <Tooltip title="Cancelar">
                              <Close
                                sx={{
                                  color: "red",
                                  fontSize: 25,
                                  opacity: editing ? 1 : 0.2,
                                }}
                              />
                            </Tooltip>
                          </IconButton>
                        ) : null}

                        <IconButton
                          sx={{ opacity: editing ? 0.2 : 1 }}
                          onClick={() => navigateToDetails(enrollmentDocument)}
                        >
                          <VisibilityIcon
                            sx={{ color: "#ccc", fontSize: 20 }}
                          />
                        </IconButton>
                        {auth.isAdmin && (
                          <IconButton
                            onClick={() =>
                              removeMovement(
                                enrollmentDocument._id,
                                "enrollment"
                              )
                            }
                          >
                            <DeleteIcon
                              sx={{
                                color: "#ccc",
                                fontSize: 20,
                                opacity: editing ? 0.2 : 1,
                              }}
                            />
                          </IconButton>
                        )}
                      </TableDataItem>
                    </tr>
                  );
                })}
              </CardTable>
            </div>
          )}

          {shift &&
            shift.shift &&
            shift.shift.comments &&
            shift.shift.comments.length > 0 && (
              <div
                className="px-4 py-3 bg-blue-900"

                style={{ border: ".5px dotted #64748b", backgroundColor: colors.sapphire }}
              >
                <p className="text-white text-lg">Comentarios</p>
                {shift.shift.comments.map((c, idx) => {
                  if (idx === 0) {
                    return null;
                  }

                  return (
                    <div className="flex items-center gap-2 mt-1">
                      {/*                       <DeleteIcon sx={{ color: "#ccc", fontSize: 20 }} />
                       */}{" "}
                      <p className="text-white font-light text-xs py-2">
                        📢 💬 {c}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}

          <div style={{backgroundColor: colors.sapphire}}>
            <p
              className="text-white text-lg  px-4 py-3"
              style={{ border: ".5px dotted " }}
            >
              Resumen del dia
            </p>

            {shift.paymentResume &&
              shift.paymentResume.map((payment) => {


                if (payment.code === "TOTAL") {
                  return (
                    <>
                      <div
                        className="flex justify-between px-4 py-2"
                        style={{ borderBottom: ".5px dotted #64748b" }}
                      >
                        <p className="text-white text-xl font-semibold my-2">
                          {payment.name}
                        </p>
                        <p className="text-white font-semibold text-xl my-2">
                          {formatCLP(payment.amount)}
                        </p>
                      </div>

                    </>
                  );
                }

              })}
          </div>
        </div>
      </div>
      <Dialog
        open={message.isOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            backgroundColor: colors.sapphire,
            borderRadius: 8,
            maxWidth: '500px', // o el valor que se ajuste bien a tu contenido
            width: '100%',     // ocupa todo el ancho disponible dentro de ese maxWidth
            overflow: 'hidden' // previene scroll innecesario
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ backgroundColor: colors.sapphire, color: "#fff" }}
        >
          {message.title}
        </DialogTitle>

        {!editing && (
          <DialogContent sx={{             backgroundColor: colors.sapphire,
          }}>
            {message.title !== "Desea eliminar este turno" ? (
                <Box sx={{ width: '100%' }}>

              <TextField
                type="number"
                onChange={handleInitialBalance}
                value={initialBalance}
                placeholder="Ingresa el saldo inicial"
                sx={{ marginRight: 2, backgroundColor: "#cbd5e1", overflow: 'hidden' }}
                className=" border-0  placeholder-blueGray-300 text-blueGray-600  rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 "
              />
                              </Box>

            ) : null}
          </DialogContent>
        )}
        <DialogActions
          sx={{
            backgroundColor: colors.sapphire,
            overflow: 'hidden'
          }}
        >
          <Button
            sx={{ color: "#fff", marginRight: 1 }}
            variant="contained"
            color="success"
            onClick={
              editing
                ? handleConfirmNewPrice
                : message.title === "Desea eliminar este turno"
                ? handleConfirmDelete
                : handleConfirm
            }
          >
            Confirmar
          </Button>
          <Button
            sx={{ color: "#fff" }}
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
